import { DropdownProps } from "components/dropdowns/models";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import React from "react";
import { type Font } from "../models";

const FontDropdown = (props: DropdownProps<Font, Font>) => {
  const options = props.options.sort().map((val) => ({
    text: val,
    value: val
  }));

  return <BaseReactSelectDropdown
    options={options}
    value={options.find(o => o.value === props.value)}
    onChange={o => { props.onChange(o.value); }}
    getLabel={item => item.text}
    getValue={item => item.value}
    excludeKeys={[]}
    config={{
      isSearchable: true,
      shouldRenderSelectedValue: true,
      ...props.config,
    }}
  />
};

export default FontDropdown;